import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getAssetsList,
  assetsListSuccessful,
  isModelVisible,
  assetByIDSuccessful
} from "./assetSlice";

// Auth Related Methods

import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
  getList
} from "../../../helpers/Helper";

import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";

function* AssetsList({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/asset/", params);
    yield put(assetsListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddAsset({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/asset/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Asset Added Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getAssetsList({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Asset. Please try again!
              </p>
            </div>
          ),
        });
      }
      // yield put(reEstimationAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/asset/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Asset Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getAssetsList({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Asset. Please try again!
              </p>
            </div>
          ),
        });
      }
      // yield put(reEstimationAddSuccessful(null));
    }
  } catch (error) {
    console.log("response", error.response);
    if (error.response.status === 400) {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              {error.response.data.error[0]}
            </p>
          </div>
        ),
      });
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Getting from server side issue!
            </p>
          </div>
        ),
      });
    }
    yield put(apiError(error));
  }
}

function* DeleteAsset({ payload }) {
  var areaID = payload;
  try {
    const response = yield call(postDelete, "/masters/asset/" + areaID);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Asset has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getAssetsList({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Asset has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

function* AssetByID({ payload }) {
  try {
    const response = yield call(
      getList,
      "/masters/asset/" + payload,
      {}
    );
    yield put(assetByIDSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}


function* watchGetAssetsList() {
  yield takeEvery("asset/getAssetsList", AssetsList);
}

export function* watchAssetAdd() {
  yield takeEvery("asset/assetAdd", AddAsset);
}

export function* watchGetAssetByID() {
  yield takeEvery("asset/getAssetByID", AssetByID);
}

export function* watchAssetDelete() {
  yield takeEvery("asset/assetDelete", DeleteAsset);
}



function* assetSaga() {
  yield all([
    fork(watchGetAssetsList),
    fork(watchAssetAdd),
    fork(watchGetAssetByID),
    fork(watchAssetDelete)
  ]);
}

export default assetSaga;
